<template>
  <section v-if="hasContent" class="lead-flow-overview-section">
    <h3>Program / Tour operator</h3>
    <dl>
      <div v-if="programExternalId">
        <dt>Itinerary</dt>
        <dd>#{{ programExternalId }}</dd>
      </div>
      <div v-if="programAmount">
        <dt>Amount</dt>
        <dd :title="programAmount">{{ programAmount }}</dd>
      </div>
      <div v-if="programConfirmed">
        <dt>Status</dt>
        <dd>Confirmed</dd>
      </div>
      <div v-if="tourOperatorName">
        <dt>Tour operator</dt>
        <dd :title="tourOperatorName">{{ tourOperatorName }}</dd>
      </div>
      <div v-if="storyClientUrl || storyItineraryUrl">
        <dt>Links</dt>
        <dd>
          <span class="lead-flow-program-details__links">
            <a
              v-if="storyClientUrl"
              :href="storyClientUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="table-default__activity table-default__activity--itinerary table-default__activity--active"
              title="Open client in Story"
              :aria-label="`Open Story client #${programExternalId}`"
            ></a>
            <a
              v-if="storyItineraryUrl"
              :href="storyItineraryUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="table-default__activity table-default__activity--clients table-default__activity--active"
              title="Open itinerary in Story"
              aria-label="Open itinerary in Story"
            ></a>
          </span>
        </dd>
      </div>
    </dl>
  </section>
</template>

<script>
export default {
  name: 'LeadProgramDetails',
  props: {
    program: {
      type: Object,
      default: null
    },
    tourOperator: {
      default: null
    }
  },
  computed: {
    programExternalId() {
      if (!this.program || this.program.itinerary_id === null || this.program.itinerary_id === undefined) return ''
      return String(this.program.itinerary_id).trim()
    },
    programHash() {
      if (!this.program || !this.program.hash) return ''
      return String(this.program.hash).trim()
    },
    storyClientUrl() {
      if (!this.programExternalId) return ''
      return `https://story.altezza.travel/clients/${encodeURIComponent(this.programExternalId)}`
    },
    storyItineraryUrl() {
      if (!this.programHash) return ''
      return `https://story.altezza.travel/itinerary/${encodeURIComponent(this.programHash)}`
    },
    programAmount() {
      if (!this.program) return ''
      if (this.program.amount === null || this.program.amount === undefined || this.program.amount === '') {
        return ''
      }
      const amount = Number(this.program.amount)
      const value = Number.isFinite(amount) ? new Intl.NumberFormat('en-GB', { maximumFractionDigits: 2 }).format(amount) : this.program.amount
      const currency = this.program.currency && this.program.currency.code
      return currency ? `${value} ${currency}` : value
    },
    programConfirmed() {
      return Boolean(this.program && this.program.confirmed)
    },
    tourOperatorName() {
      if (!this.tourOperator) return ''
      if (typeof this.tourOperator === 'string') return this.tourOperator
      return this.tourOperator.business_name
        || this.tourOperator.name
        || this.tourOperator.identifier
        || ''
    },
    hasContent() {
      return Boolean(
        this.programExternalId ||
        this.programAmount ||
        this.programConfirmed ||
        this.tourOperatorName ||
        this.programHash
      )
    }
  }
}
</script>

<style scoped>
.lead-flow-program-details__links {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
</style>
